import { useState } from "react";
import Navigation from "@/components/Navigation";
import VideoFeed from "@/components/VideoFeed";
import AuthGate from "@/components/auth/AuthGate";

/**
 * Accueil public : le feed est visible par tous, mais reste figé derrière le
 * voile d'authentification tant que le compte n'est pas connecté et finalisé.
 */
const Feed = () => {
  const [locked, setLocked] = useState(false);

  return (
    <div className="app-screen overflow-hidden">
      <main className="h-full pb-0 md:pb-0">
        <VideoFeed interactionLocked={locked} />
      </main>
      <Navigation />
      <AuthGate onLockChange={setLocked} />
    </div>
  );
};

export default Feed;
